import axios, { AxiosResponse } from "axios"
import { SearchResult } from "types/search"

// there is no FormData when we do SSR
// so we use encodeURIComponent to do the same

function doSearch(query: string) {
	return axios.post<any, AxiosResponse<SearchResult>>(
		"/doSearch",
		`q=${encodeURIComponent(query)}`
	)
}

export default doSearch
